"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSplitActivityProgressionValueForObjectiveLiteral = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _moment = _interopRequireDefault(require("moment"));

var _index = _interopRequireDefault(require("../display/index"));

var _formatNumberWithThousandSeparators = _interopRequireDefault(require("../display/formatNumberWithThousandSeparators"));

var _formatDistanceWithMeasurementSystem = _interopRequireDefault(require("../display/formatDistanceWithMeasurementSystem"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getSplitActivityProgressionValueForObjectiveLiteral = function getSplitActivityProgressionValueForObjectiveLiteral(_ref) {
  var objective = _ref.objective,
      splitActivity = _ref.splitActivity,
      _ref$measurementSyste = _ref.measurementSystem,
      measurementSystem = _ref$measurementSyste === void 0 ? 'metric' : _ref$measurementSyste,
      t = _ref.t,
      _ref$precision = _ref.precision,
      precision = _ref$precision === void 0 ? 0 : _ref$precision;

  if (!objective) {
    return '';
  }

  if (objective.repeat) {
    var _splitActivity$activi;

    var repeat = (splitActivity === null || splitActivity === void 0 ? void 0 : (_splitActivity$activi = splitActivity.activityIds) === null || _splitActivity$activi === void 0 ? void 0 : _splitActivity$activi.length) || (splitActivity === null || splitActivity === void 0 ? void 0 : splitActivity.userActionsCount) || 0;
    return "".concat(repeat);
  }

  if (objective.minPoints || objective.unit === 'points') {
    var value = (splitActivity === null || splitActivity === void 0 ? void 0 : splitActivity['points']) || 0;
    return "".concat(value);
  }

  if (objective.minDistance || objective.unit === 'distance') {
    var distance = (splitActivity === null || splitActivity === void 0 ? void 0 : splitActivity['distance']) || 0;

    var _value = (0, _formatDistanceWithMeasurementSystem["default"])({
      distance: distance,
      measurementSystem: measurementSystem,
      unit: 'distance',
      precision: precision
    });

    var unit = t("ds-leaderboard.unit.".concat(_index["default"].extractTargetUnit({
      measurementSystem: measurementSystem,
      unit: 'distance'
    })));
    return "".concat((0, _formatNumberWithThousandSeparators["default"])(_value), " ").concat(unit);
  }

  if (objective.minClimb || objective.unit === 'climb') {
    var _distance = (splitActivity === null || splitActivity === void 0 ? void 0 : splitActivity['climb']) || 0;

    var _value2 = (0, _formatDistanceWithMeasurementSystem["default"])({
      distance: _distance,
      measurementSystem: measurementSystem,
      unit: 'climb'
    });

    var _unit = t("ds-leaderboard.unit.".concat(_index["default"].extractTargetUnit({
      measurementSystem: measurementSystem,
      unit: 'climb'
    })));

    return "".concat((0, _formatNumberWithThousandSeparators["default"])(_value2), " ").concat(_unit);
  }

  if (objective.minDescent || objective.unit === 'descent') {
    var _distance2 = (splitActivity === null || splitActivity === void 0 ? void 0 : splitActivity['descent']) || 0;

    var _value3 = (0, _formatDistanceWithMeasurementSystem["default"])({
      distance: _distance2,
      measurementSystem: measurementSystem,
      unit: 'descent'
    });

    var _unit2 = t("ds-leaderboard.unit.".concat(_index["default"].extractTargetUnit({
      measurementSystem: measurementSystem,
      unit: 'descent'
    })));

    return "".concat((0, _formatNumberWithThousandSeparators["default"])(_value3), " ").concat(_unit2);
  }

  if (objective.minDuration || objective.unit === 'duration') {
    var duration = (splitActivity === null || splitActivity === void 0 ? void 0 : splitActivity['duration']) || 0;

    var durationObject = _moment["default"].duration(duration, 'seconds')._data;

    return t('ds-challenges.timeframe.remainingtime', _objectSpread({}, durationObject));
  }

  return '';
};

exports.getSplitActivityProgressionValueForObjectiveLiteral = getSplitActivityProgressionValueForObjectiveLiteral;
//# sourceMappingURL=getSplitActivityProgressionForObjectiveLiteral.js.map